/**
 * UnsavedCasesDialog Component
 *
 * Displays a confirmation dialog when the user tries to navigate away from the
 * moderation work queue with unsubmitted reports. Gives the user the choice to
 * stay on the page or leave (discarding progress).
 */

import { Dialog } from '@soteria/design-system-ve';
import type { ReactElement } from 'react';
import type { Blocker } from 'react-router-dom';

interface UnsavedCasesDialogProps {
  /** React Router blocker instance from `useModerationNavigationGuard` */
  blocker: Blocker;
}

/** Warning dialog shown when navigating away with unsubmitted moderation reports */
export function UnsavedCasesDialog({ blocker }: UnsavedCasesDialogProps): ReactElement | null {
  if (blocker.state !== 'blocked') return null;

  return (
    <Dialog
      isOpen
      description="You have unsubmitted moderation reports. If you leave now, your progress will be lost."
      primaryAction={{
        label: 'Stay on Page',
        onClick: () => blocker.reset(),
        variant: 'primary',
      }}
      secondaryAction={{
        label: 'Leave Page',
        onClick: () => blocker.proceed(),
        variant: 'danger',
      }}
      title="Unsaved Reports"
      onClose={() => blocker.reset()}
    >
      {null}
    </Dialog>
  );
}
